import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]验证手机图像验证码
 */
export function utilServer_checkImageCodeUsingPOST(
  req: UtilServer.ImageCodeDto | void,
  config?: RequestConfig
): Promise<string> {
  return resource.postNoAuth('/phone/checkImageCode', req, config);
}

/**
 * [No Auth]验证手机数字验证码
 */
export function utilServer_checkPhoneCodeUsingPOST(
  req: UtilServer.PhoneCodeDto | void,
  config?: RequestConfig
): Promise<string> {
  return resource.postNoAuth('/phone/checkPhoneCode', req, config);
}

/**
 * [No Auth]获取手机图像验证码
 */
export function utilServer_getImageCodeUsingPOST(
  req: UtilServer.ImageCodeDto | void,
  config?: RequestConfig
): Promise<void> {
  return resource.postNoAuth('/phone/getImageCode', req, config);
}

/**
 * [No Auth]获取手机数字验证码
 */
export function utilServer_getPhoneCodeUsingPOST(
  req: UtilServer.PhoneCodeDto | void,
  config?: RequestConfig
): Promise<string> {
  return resource.postNoAuth('/phone/getPhoneCode', req, config);
}

/**
 * [No Auth]发送手机短信
 */
export function utilServer_sendPhoneMessageUsingPOST(
  req: UtilServer.PhoneMessageDto | void,
  config?: RequestConfig
): Promise<string> {
  return resource.postNoAuth('/phone/sendPhoneMessage', req, config);
}
